import { createAction } from '@reduxjs/toolkit'

export const setModal = createAction<any>('action/setModal')
